var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.25H9C8.59 11.25 8.25 10.91 8.25 10.5C8.25 10.09 8.59 9.75 9 9.75H16C16.41 9.75 16.75 10.09 16.75 10.5C16.75 10.91 16.41 11.25 16 11.25Z",
    fill: "#4F5B92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.3199C16.16 22.3199 15.82 22.22 15.53 22.03L11.27 19.1899H7.5C4.06 19.1899 1.75 16.8799 1.75 13.4399V7.43994C1.75 3.99994 4.06 1.68994 7.5 1.68994H17.5C20.94 1.68994 23.25 3.99994 23.25 7.43994V13.4399C23.25 16.6199 21.27 18.84 18.25 19.15V20.5699C18.25 21.2199 17.9 21.8099 17.33 22.1099C17.07 22.2499 16.78 22.3199 16.5 22.3199ZM7.5 3.17993C4.92 3.17993 3.25 4.84993 3.25 7.42993V13.4299C3.25 16.0099 4.92 17.6799 7.5 17.6799H11.5C11.65 17.6799 11.79 17.7199 11.92 17.8099L16.37 20.77C16.48 20.84 16.58 20.81 16.63 20.78C16.68 20.75 16.76 20.6899 16.76 20.5599V18.4299C16.76 18.0199 17.1 17.6799 17.51 17.6799C20.09 17.6799 21.76 16.0099 21.76 13.4299V7.42993C21.76 4.84993 20.09 3.17993 17.51 3.17993H7.5Z",
    fill: "#4F5B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage2);
export default __webpack_public_path__ + "static/media/message-2.e79348b5d951836b693ef023d4e55c80.svg";
export { ForwardRef as ReactComponent };